import { z } from 'zod/v3';

export const UserFollowedDataObjectGroupMutationDtoSchema = z.object({
  dataObjectGroupId: z.number().optional(),
  periodSkipCount: z.number().optional(),
});
